module.exports = __webpack_public_path__ + "img/img5.bdab42e7.jpg";